// Eigenbau: Firmenzeichen und Wortmarke als Paar. Tremors `Logo` im Bestand
// ist das Tremor-Logo selbst, kein Rahmen für ein fremdes Zeichen.

import logo from "@/bilder/logo-128.png";
import { cx } from "@/lib/utils";

/**
 * Das Zeichen von cubic studio.
 *
 * Das Bild bringt den Raben und den Würfel mit; „cubic studio" steht als Text
 * daneben und nicht als Teil der Grafik. Zwei Gründe: Der Schriftzug bleibt
 * suchbar, markierbar und skaliert mit der Schriftgröße des Systems — und die
 * Zweifarbigkeit („cubic" weiß, „studio" im Akzent) stammt aus dem Entwurf und
 * gehört damit ins Stylesheet, nicht in eine Pixeldatei.
 *
 * Das Zeichen ist absichtlich größer als der Zeilenkasten der Schrift: Der
 * Würfel läuft an allen vier Seiten spitz zu, und bei gleicher Höhe wie die
 * Versalhöhe wirkt er kleiner als er ist.
 */
export function Wortmarke({
  groesse = 26,
  nurZeichen = false,
  mitZeichen = true,
  aufDunkel = false,
  className,
}: {
  /** Kantenlänge des Zeichens in Pixeln. */
  groesse?: number;
  /** Nur das Zeichen zeigen — für die eingeklappte Leiste. */
  nurZeichen?: boolean;
  /** Das Bildzeichen ergänzen. Die neue Schiene führt bewusst nur die Wortmarke. */
  mitZeichen?: boolean;
  /**
   * Fest auf dunklem Grund. Die Seitenleiste ist im Entwurf immer dunkel,
   * unabhängig vom Theme — dort wäre ein themenabhängiges `dark:` falsch,
   * weil es im hellen Theme schwarze Schrift auf Schwarz ergäbe.
   */
  aufDunkel?: boolean;
  className?: string;
}) {
  return (
    <span className={cx("flex items-center gap-x-2", className)}>
      {mitZeichen ? (
        <img
          src={logo}
          alt=""
          aria-hidden="true"
          width={groesse}
          height={groesse}
          className="block flex-none"
          style={{ width: groesse, height: groesse }}
          draggable={false}
        />
      ) : null}
      {nurZeichen && mitZeichen ? (
        <span className="sr-only">cubic studio</span>
      ) : (
        /*
          Maße aus dem Entwurf: 14.5px Mono, `-0.02em` Sperrung, „cubic" in
          500 und „studio" in 400. Vorher stand hier `text-base` (16px) mit
          `font-semibold` (600) — eine halbe Stufe zu groß und eine ganze zu
          fett, was die Marke neben dem 26px-Zeichen schwerer machte als den
          Rest der Schiene.

          Die Farben kommen aus den Rollen, nicht aus `blue-*`: Auf der Tafel
          ist der Akzent fest `--tafel-akzent` (#29E2BE), weil sie in beiden
          Themen dunkel bleibt. Nur die helle Kopfzeile unter 1024px kippt mit
          dem Thema.
        */
        <span className="font-mono text-[14.5px] tracking-[-0.02em]">
          <span
            className={cx(
              "font-medium",
              aufDunkel ? "text-tafel-tinte" : "text-tinte dark:text-tafel-tinte",
            )}
          >
            cubic
          </span>
          <span
            className={cx(
              "font-normal",
              aufDunkel ? "text-tafel-akzent" : "text-akzent",
            )}
          >
            {" "}
            studio
          </span>
        </span>
      )}
    </span>
  );
}
